export default {
  en: {
    snack: {
      approve_success: 'Term approved successfully',
      decline_success: 'Term declined successfully',
      undo_decline_success: 'Term undo successfully',
      delete_success: 'Term deleted successfully',
      generic_error: 'Something went wrong',
    },
    confirm_dialog_msg: {
      default: 'Are you sure?',
    },
    actions: {
      approve: 'Approve',
      decline: 'Decline',
      undo: 'Undo',
      contact: 'Contact',
      edit: 'Edit',
      delete: 'Delete',
      cancel: 'Cancel',
    },
  },
};
